export const DesktopFeature = {
	mask: {
		id: 'mask',
		version: 72,
	},
	restart: {
		id: 'restart',
		version: 74,
	},
	accountManagement: {
		id: 'accountManagement',
		version: 75,
	},
	openNewTab: {
		id: 'openNewTab',
		version: 76,
	},
	openPage: {
		id: 'openPage',
		version: 79,
	},
	portalTabActivation: {
		id: 'portalTabActivation',
		version: 85,
	},
};
